$ = require 'jquery'
h = require './helpers'

class TouristQuestionnaires
  applyStyles: ->
    console.log 'Применяю стили TouristQuestionnaires'
    $form = $('#aspnetForm')

#    $form.find('table').show()
    $staff = $form.children()

    #    h.h1('Регистрация партнера', 'h1-personal-page').appendTo $form
    [$row, $wrapper] = h.rowN(true, 'tourist-questionnaires-content')
    $form.append $row

    $staff.appendTo $wrapper

    $("#aspnetForm").contents().filter ->
      (this.nodeType == 3)
    .remove()

    $aLabel = $ '<label for="ctl00_generalContent_CmbQuestionnaires_TextBox">Выберите анкету: </label>'
    $('#ctl00_generalContent_CmbQuestionnaires_TextBox').before($aLabel)
    $tLabel = $ '<label for="ctl00_generalContent_CmbTourists_TextBox">Выберите туриста: </label>'
    $('#ctl00_generalContent_CmbTourists_TextBox').before($tLabel)

    $('#ctl00_generalContent_BtnPrint').hide()

module.exports = new TouristQuestionnaires